
<template>
  <div class="modal_card reverse" style="width: 100vw">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>{{commission.id ? 'Редактировать членов комиссии' : 'Создание комиссии'}}</h1>
        <b-field
            label="Название комиссии"
            class="modal_select big_field has_icon grey"
            type="is-info"
            :message="errors.first('commissionName')"
            :class="errors.first('commissionName') ? 'error' : ''"
          >
          <b-input
            :name="'commissionName'"
            type="text"
            v-model="commission.name"
            placeholder="Название комиссии"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <b-collapse
          v-for="(user, i) in commission.members"
          animation=""
          :key="i"
          :open="isOpen"
          aria-id="modal-users-list"
          class="modal-users-list"
        >
          <div class="list_header users active" slot="trigger" aria-controls="modal-users-list">
            <span class="left"> <i class="icon-button-arrow"></i>Пользователь - {{ i + 1 }} </span>
            <span class="delete-button" @click="$event.stopPropagation(); removeMember(i)">
              <i class="mdi mdi-delete"></i>
            </span>
          </div>
          <b-field
            label="Имя:"
            type="is-info"
            class="left_input"
            :message="errors.first('name' + i)"
            :class="errors.first('name' + i) ? 'error' : ''"
          >
            <b-input
              :name="'name' + i"
              type="text"
              placeholder="Имя"
              v-model="user.name"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
          <b-field
            label="Фамилия:"
            type="is-info"
            class="right_input"
            :message="errors.first('surname' + i)"
            :class="errors.first('surname' + i) ? 'error' : ''"
          >
            <b-input
              :name="'surname' + i"
              type="text"
              placeholder="Фамилия"
              v-model="user.surname"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
          <b-field
            label="Отчество:"
            type="is-info"
            class="left_input"
            :message="errors.first('patronymic' + i)"
            :class="errors.first('patronymic' + i) ? 'error' : ''"
          >
            <b-input
              :name="'patronymic' + i"
              type="text"
              placeholder="Отчество"
              v-model="user.patronymic"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
          <b-field
            label="Должность:"
            type="is-info"
            class="right_input"
            :message="errors.first('position' + i)"
            :class="errors.first('position' + i) ? 'error' : ''"
          >
            <b-input
              :name="'position' + i"
              type="text"
              placeholder="Должность"
              v-model="user.position"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
        </b-collapse>
        <div class="add-user" @click="addMember">Добавить нового пользователя</div>
        <button @click="submitBranch" class="add_user_button modal_button left_button" type="submit" :disabled="errors.items.length > 0">
          Сохранить
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    commission: {
      default: () => {},
      type: Object
    }
  },
  data() {
    return {
      isOpen: true
    }
  },
  created() {
    this.updateDict()
  },
  methods: {
     updateDict() {
      let dict = {
        custom: {}
      }
      for (let i = 0; i < this.commission.members.length; i++) {
        dict.custom['name' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
        dict.custom['surname' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
        dict.custom['patronymic' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
        dict.custom['position' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
      }
      dict.custom['commissionName'] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
      this.$validator.localize('ru', dict)
    },
    submitBranch() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit(this.commission.id ? 'edit': 'create')
         
        }
      })
    },
    removeMember(index) {
      this.commission.members.splice(index, 1)
    },
    addMember() {
      this.commission.members.push({
        name: '',
        surname: '',
        patronymic: '',
        position: ''
      })
      this.updateDict()
    }  
  }
}
</script>